import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Severity } from '@gripp/shared-logic';
import { ReactNode } from 'react';
import {
  Platform,
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { Colors } from '../../../themes';
import { SeverityIcons } from '../../issue/severityIcons';

type RoutineButtonProps = {
  onClick: () => void;
  text: string;
  buttonStyle?: StyleProp<ViewStyle>;
  buttonIcon?: Severity;
  buttonIconStyle?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<ViewStyle>;
  buttonLabelStyle?: StyleProp<TextStyle>;
  leftButtonIcon?: ReactNode;
  children?: ReactNode;
  underlineInfoText?: string;
  secondaryButtonIcon?: ReactNode;
  disabled?: boolean;
};

export const RoutineButton = (props: RoutineButtonProps) => {
  return (
    <TouchableOpacity
      onPress={props.onClick}
      style={[
        styles.button,
        props.buttonStyle,
        props.disabled && styles.disabled,
      ]}
      activeOpacity={0.7}
      disabled={props.disabled}
    >
      {props.leftButtonIcon && (
        <View style={{ marginRight: 4 }}>{props.leftButtonIcon}</View>
      )}

      {props.buttonIcon && (
        <MaterialCommunityIcons
          name={SeverityIcons[props.buttonIcon]}
          size={20}
          style={props.buttonIconStyle ? props.buttonIconStyle : styles.icon}
        />
      )}
      <Text
        style={[styles.buttonLabel, props.buttonLabelStyle, props.labelStyle]}
      >
        {props.text}
      </Text>
      {props.underlineInfoText && <Text>{props.underlineInfoText}</Text>}
      {props.children}
      <View style={styles.rightIconContainer}>
        {props.secondaryButtonIcon}
        <MaterialCommunityIcons
          style={styles.whiteIconStyle}
          name="chevron-right"
        />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: Colors.blue,
    borderRadius: 8,
    borderColor: Colors.blue,
    borderWidth: 2,
    height: 44,
    paddingLeft: 20,
    paddingRight: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonLabel: {
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: 0,
    color: Colors.white,
    fontFamily: 'Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
    ...Platform.select({
      web: {
        color: Colors.blackText,
      },
    }),
  },
  whiteIconStyle: {
    color: Colors.white,
    fontSize: 22,
  },
  icon: {
    color: Colors.white,
    ...Platform.select({
      web: {
        marginBottom: 0,
        marginRight: 6,
      },
      default: {
        marginBottom: 2,
      },
    }),
  },
  rightIconContainer: {
    flexDirection: 'row',
    columnGap: 2,
    marginLeft: 'auto',
  },
  disabled: {
    opacity: 0.5,
  },
});
